import {
  SET_CALCULATE_GRID_SELECTED_ITEM,
  SET_CALCULATE_ANCHOR_IMAGE_SRC,
  SET_CALCULATE_INSTALLATION_METHOD_IMAGE_SRC,
  SET_CALCULATE_INSTALLATION_DATA, 
  SET_CALCULATE_ERROR_MESSAGES,
  SET_CALCULATE_WAITING_FOR_ERRORS, 
  SET_FEM_CALCULATION,
  SET_FEM_OPTIMIZATION,
  SET_FEM_RESULTS,
  RESET_FEM_RESULTS,
  SET_CALCULATE_STATE,
  RESET_CALCULATE_STATE,
  SET_PROFILE_RESISTANCE,
  SCROLL_TO_SELECTED_RESULT,
  SET_CALCULATE_FILTER,
  SET_REPORT_PROJECT_NAME,
  SET_REPORT_FASTENING_POINT,
  SET_REPORT_LOCATION,
  SET_REPORT_CONTACT_NAME,
  SET_REPORT_COMPANY_NAME,
  SET_REPORT_PHONE_NUMBER,
  SET_REPORT_MAIL_ADDRESS,
  SET_REPORT_COMMENT,
  SET_REPORT_LANGUAGE,
  SET_REPORT_DIM_3D,
  SET_FEM_OPTIONS,
  SET_CALCULATE_GRID_SELECTED_NAIL_ITEM,
  SET_CALCULATE_NAIL_IMAGE_SRC,
  SET_CALCULATE_NAILS_FILTER
} from './actions';
import { mergeDeep } from '@services/helper.service';
import { APP_TYPES } from '@config';

export const initState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    gridSelectedItem: null,
    anchorImageSrc: null,
    installationMethodImageSrc: null,
    installationData: [],
    errorMessages: [],
    isWaitingForErrors: false,
    FEM: {
      isCalculating: false,
      optimizePlateThickness: false,
      FEMOptions: {
        overrideDefault: false,
        meshStep: 0,
        anchorRigidity: 0,
        plateThicknessStep: 0,
        maximumDisplacementRatio: 0,
        maximumDisplacement: 0,
        maximumStress: 0
      }
    },
    filters: {
      status: 'ALL',
      steelType: 'ALL',
      diameter: 'ALL',
      anchorType: 'ALL',
      product: 'ALL',
      productRange: 'ALL'
    }
  },

  [APP_TYPES.BRACKET_ATTACHMENT]: {
    gridSelectedItem: null,
    anchorImageSrc: null,
    installationMethodImageSrc: null,
    installationData: [],
    errorMessages: [],
    isWaitingForErrors: false,
    FEM: {
      isCalculating: false,
      optimizePlateThickness: false,
      FEMOptions: {
        overrideDefault: false,
        meshStep: 0,
        anchorRigidity: 0,
        plateThicknessStep: 0,
        maximumDisplacementRatio: 0,
        maximumDisplacement: 0,
        maximumStress: 0
      }
    },
    filters: {
      status: 'ALL',
      steelType: 'ALL',
      diameter: 'ALL',
      anchorType: 'ALL',
      product: 'ALL',
      productRange: 'ALL'
    }
  },

  [APP_TYPES.SAFETY_BARRIER]: {
    gridSelectedItem: null,
    anchorImageSrc: null,
    installationMethodImageSrc: null,
    installationData: [],
    errorMessages: [],
    isWaitingForErrors: false,
    FEM: {
      isCalculating: false,
      optimizePlateThickness: false,
      FEMOptions: {
        overrideDefault: false,
        meshStep: 0,
        anchorRigidity: 0,
        plateThicknessStep: 0,
        maximumDisplacementRatio: 0,
        maximumDisplacement: 0,
        maximumStress: 0
      }
    },
    profileResistance: {
      isSuitable: false
    },
    filters: {
      status: 'ALL',
      steelType: 'ALL',
      diameter: 'ALL',
      anchorType: 'ALL',
      product: 'ALL',
      productRange: 'ALL'
    }
  },

  [APP_TYPES.REBAR_REINFORCEMENT]: {
    gridSelectedItem: null,
    anchorImageSrc: null,
    installationMethodImageSrc: null,
    installationData: [],
    errorMessages: [],
    isWaitingForErrors: false
  },

  [APP_TYPES.WOOD_CONNECTION]: {
    gridSelectedItem: null,
    gridSelectedNailItem: null,
    anchorImageSrc: null,
    nailImageSrc: null,
    grid: [],
    errorMessages: [],
    nailErrorMessages: [],
    isWaitingForErrors: false,
    FEM: {
      isCalculating: false,
      optimizePlateThickness: false,
      FEMOptions: {
        overrideDefault: false,
        meshStep: 2,
        anchorRigidity: 15000,
        plateThicknessStep: 2,
        maximumDisplacementRatio: 0.333,
        maximumDisplacement: 10,
        maximumStress: null
      },
      recommendedPlateThickness: 0,
      maximumDisplacement: 0,
      relativeDisplacement: 0,
      maxVonMisesStress: 0,
      isValid: false,
      structureAnalysisStatus: false
    },
    filters: {
      status: 'ALL',
      steelType: 'ALL',
      diameter: 'ALL',
      anchorType: 'ALL',
      product: 'ALL',
      productRange: 'ALL'
    },
    nailFilters: {
      status: 'ALL',
      nailType: 'ALL',
      product: 'ALL',
    }
  },

  report: {
    projectName: "",
    fasteningPoint: "",
    location: "",
    contactName: "",
    companyName: "",
    phoneNumber: "",
    mailAddress: "",
    comment: "",
    language: "",
    showDim3d: false
  }
};

const calculate = (state = initState, action) => {
    switch (action.type) {
    case RESET_CALCULATE_STATE: {
        return initState;
    }
    case SET_CALCULATE_STATE: {
        if (!action.state.report) {
          return mergeDeep({}, action.state, initState.report);
        }
        return action.state;
    }
    case SET_CALCULATE_GRID_SELECTED_ITEM: {
      return mergeDeep({}, state, {
        [action.appType]: {
          gridSelectedItem: action.value,
        }
      });
    }
    case SET_CALCULATE_GRID_SELECTED_NAIL_ITEM: {
      return mergeDeep({}, state, {
        [action.appType]: {
          gridSelectedNailItem: action.value,
        }
      });
    }
    case SET_CALCULATE_ANCHOR_IMAGE_SRC: {
      return mergeDeep({}, state, {
        [action.appType]: {
          anchorImageSrc: action.imageSrc
        }
      });
    }
    case SET_CALCULATE_NAIL_IMAGE_SRC: {
      return mergeDeep({}, state, {
        [action.appType]: {
          nailImageSrc: action.imageSrc
        }
      });
    }
    case SET_CALCULATE_INSTALLATION_DATA: {
      return mergeDeep({}, state, {
        [action.appType]: {
          installationData: action.value
        }
      });
    }
    case SET_CALCULATE_INSTALLATION_METHOD_IMAGE_SRC: {
      return mergeDeep({}, state, {
        [action.appType]: {
          installationMethodImageSrc: action.imageSrc
        }
      });
    }
    case SET_CALCULATE_ERROR_MESSAGES: {
      return mergeDeep({}, state, {
        [action.appType]: {
          errorMessages: action.value,
          isWaitingForErrors: false
        }
      });
    }
    case SET_CALCULATE_WAITING_FOR_ERRORS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          isWaitingForErrors: action.value
        }
      });
    }
    case SET_FEM_CALCULATION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          FEM: mergeDeep({}, state[action.appType].FEM, { isCalculating: action.value })
        }
      });
    }
    case SET_FEM_OPTIMIZATION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          FEM: mergeDeep({}, state[action.appType].FEM, { optimizePlateThickness: action.value })
        }
      });
    }
    case SET_FEM_OPTIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          FEM: {
            FEMOptions: mergeDeep({}, state[action.appType].FEM.FEMOptions, action.options)
          }
        }
      });
    }
    case SET_FEM_RESULTS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          FEM: mergeDeep({}, state[action.appType].FEM, {
            isValid: action.results.IsValid,
            maxVonMisesStress: action.results.MaxVonMisesStress,
            maximumDisplacement: action.results.MaximumDisplacement,
            recommendedPlateThickness: action.results.RecommendedPlateThickness,
            relativeDisplacement: action.results.RelativeDisplacement,
            structureAnalysisStatus: action.results.StructureAnalysisStatus
          })
        }
      });
    }
    case RESET_FEM_RESULTS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          FEM: mergeDeep({}, state[action.appType].FEM, { isValid: false })
        }
      });
    }
    case SET_PROFILE_RESISTANCE: {
      return mergeDeep({}, state, {
        [action.appType]: {
          profileResistance: {
            isSuitable: action.value.IsProfileSuitable,
            MRd: action.value.ProfileResistanceMRd,
            MSd: action.value.ProfileResistanceMSd,
            Iy: action.value.ProfileResistanceIy,
            Iywlim: action.value.ProfileResistanceIywlim
          }
        }
      });
    }
    case SCROLL_TO_SELECTED_RESULT: {
      return mergeDeep({}, state, {
        [action.appType]: {
          scrollToSelectedResult: action.value
        }
      });
    }
    case SET_CALCULATE_FILTER: {
      return mergeDeep({}, state, {
        [action.appType]: {
          filters: {
            [action.filterType]: action.filterValue
          }
        }
      });
    }
    case SET_CALCULATE_NAILS_FILTER: {
      return mergeDeep({}, state, {
        [action.appType]: {
          nailFilters: {
            [action.filterType]: action.filterValue
          }
        }
      });
    }
    case SET_REPORT_PROJECT_NAME: {
      return mergeDeep({}, state, {
        report: {
          projectName: action.value
        }
      });
    }
    case SET_REPORT_FASTENING_POINT: {
      return mergeDeep({}, state, {
        report: {
          fasteningPoint: action.value
        }
      });
    }
    case SET_REPORT_LOCATION: {
      return mergeDeep({}, state, {
        report: {
          location: action.value
        }
      });
    }
    case SET_REPORT_CONTACT_NAME: {
      return mergeDeep({}, state, {
        report: {
          contactName: action.value
        }
      });
    }
    case SET_REPORT_COMPANY_NAME: {
      return mergeDeep({}, state, {
        report: {
          companyName: action.value
        }
      });
    }
    case SET_REPORT_PHONE_NUMBER: {
      return mergeDeep({}, state, {
        report: {
          phoneNumber: action.value
        }
      });
    }
    case SET_REPORT_MAIL_ADDRESS: {
      return mergeDeep({}, state, {
        report: {
          mailAddress: action.value
        }
      });
    }
    case SET_REPORT_COMMENT: {
      return mergeDeep({}, state, {
        report: {
          comment: action.value
        }
      });
    }
    case SET_REPORT_LANGUAGE: {
      return mergeDeep({}, state, {
        report: {
          language: action.value
        }
      });
    }
    case SET_REPORT_DIM_3D: {
      return mergeDeep({}, state, {
        report: {
          showDim3d: action.value
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default calculate;



// WEBPACK FOOTER //
// ./src/reducers/selectors/calculate/index.js